export const FILTER_LIST_GENERIC_ACTIVITY_LIST_SORT = 'FILTER_LIST_GENERIC_ACTIVITY_LIST_SORT_KEY';

export const FILTER_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'FILTER_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
